export const normalizeItemTypes = (rawData) => {
  const itemTypes = {};
  const itemVariants = {};
  const result = [];

  rawData.forEach(type => {
    const variantIds = (type.variants || []).map(v => v.id);
    itemTypes[type.id] = { ...type, variants: variantIds };
    result.push(type.id);

    (type.variants || []).forEach(variant => {
      itemVariants[variant.id] = { ...variant, itemType: type.id };
    });
  });

  return {
    result,
    entities: { itemTypes, itemVariants },
  };
}
